import { Component, OnInit, AfterContentInit, Inject, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../common/shared.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ToastrService } from "ngx-toastr";
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Http } from '@angular/http';

/**
 * Author: gomsmaasi
 * 
 * Date Created: March 27th 2018
 * 
 * Description: Component class for Unsubscribe - /unsubscribe
 **/
@Component({
  selector: 'gosg-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.css']
})
export class UnsubscribeComponent implements OnInit, AfterViewInit {
  emailId: any;
  lang = this.lang;
  languageId = this.languageId;
  loading = false;
  unsubcribeStat = true;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private http: Http,

    @Inject(APP_CONFIG) private config: AppConfig,
  ) {
    this.lang = translate.currentLang;
    this.languageId = 2;
    this.loading = true;
    translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;

      if (myLang == 'en') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.languageId = 1;
        });

      }
      if (myLang == 'ms') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.languageId = 2;
        });
      }
      // Some Functions goes here;
      this.loading = false;

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = title +this.translate.instant('home.breadcrumb.unsubscribe');
          this.sharedService.setTitle(title);
        }); 
      },500);

    });
  }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.queryParams.subscribe(params => {
      this.emailId = params['code'];
      this.loading = false;
  });
  }

  ngAfterViewInit() {
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = title +this.translate.instant('home.breadcrumb.unsubscribe');
      this.sharedService.setTitleAndGtag(title);
    }); 
  }

  unsubs(){
    this.loading = true;
    return this.http.get(this.config.urlPortal + 'subscription/unsub?code='+this.emailId+ '&language='+ this.languageId).subscribe(
      data => {

        let errMsg = "";
        errMsg = JSON.parse(data["_body"]).statusCode;

        if(errMsg.toLowerCase() == 'success'){
          this.sharedService.showSuccess(this.translate.instant('subscription.unsubMsg'), '');
        }

        else{
          this.sharedService.showError(JSON.parse(data["_body"]).statusDesc, '');
        }

        this.unsubcribeStat = false;
        this.loading = false;
      }
      , error => {
        this.loading = false;
        // this.sharedService.showError('Token is invalid');
      }
    )

  }

  subs(){
    this.router.navigate(['subscription']);
  }

  gotoHome(){
    this.router.navigate(['index']);
  }
}



// WEBPACK FOOTER //
// ./src/app/unsubscribe/unsubscribe.component.ts